const configurations = [
  {
    id: "111-111",
    name: "Vonios spintelė",
    parameters: ["Plotis", "Spalva"],
    image:
      "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_1000_light.png",
  },
  {
    id: "222-222",
    name: "TV staliukas",
    parameters: ["Plotis", "Spalva"],
    image:
      "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_2100_light.png",
  },
];

export default configurations;